/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SuperhomeInputs */

const cs_enum_superhome = /** @type {(inputs: Enum_SuperhomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SuperHome`)
};

const en_enum_superhome = /** @type {(inputs: Enum_SuperhomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SuperHome`)
};

/**
* | output |
* | --- |
* | "SuperHome" |
*
* @param {Enum_SuperhomeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_superhome = /** @type {((inputs?: Enum_SuperhomeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SuperhomeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_superhome(inputs)
	return cs_enum_superhome(inputs)
});